<script setup lang="ts">
import { Badge } from "@/components/ui/badge";

const props = defineProps({
  type: {
    type: String,
    required: true
  }
})

const variantMap: Record<string, string> = {
  headquarter: 'tw:bg-indigo-200',
  local_entity: 'tw:bg-sky-200',
  event: 'tw:bg-orange-200',
  retail_store: 'tw:bg-emerald-200',
  warehouse: 'tw:bg-slate-200',
  ambassador: 'tw:bg-violet-200',
  press: 'tw:bg-pink-200',
  other: 'tw:bg-gray-200',
  main: 'tw:bg-indigo-300',
  guest: 'tw:bg-yellow-200',
}
</script>

<template>
  <Badge variant="zinc" :class="[
      variantMap[props.type] || ''
    ]">
    <slot></slot>
  </Badge>
</template>